module.exports = "/assets/data/5bf8fd1806a014766952b0286d850d4c-NG3.data.json";